import React, { useCallback, useEffect, createContext } from 'react';
import { createPortal } from 'react-dom';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import OutsideClickHandler from 'react-outside-click-handler';
import cn from 'classnames';
import styles from './Modal.module.sass';
import Icon from '../Icon';

export const ModalContext = createContext(); 

const Modal = ({
    outerClassName,
    containerClassName,
    visible,
    onClose,
    title,
    children,
}) => {
    const escFunction = useCallback(
        (e) => {
            if (e.keyCode === 27) {
                onClose();
            }
        },
        [onClose]
    );

    useEffect(() => {
        document.addEventListener('keydown', escFunction, false);
        return () => {
            document.removeEventListener('keydown', escFunction, false);
        };
    }, [escFunction]);

    useEffect(() => {
        if (visible) {
            const target = document.querySelector('#modal');
            disableBodyScroll(target);
        } else {
            clearAllBodyScrollLocks();
        }
    }, [visible]);

    return createPortal(
        visible && (
            <ModalContext.Provider value={ {close: onClose} }>
                <div className={styles.modal} id='modal'>
                    <div className={cn(styles.outer, outerClassName)}>
                        <OutsideClickHandler onOutsideClick={onClose}>
                            <div
                                className={cn(styles.container, containerClassName)}
                            >
                                {title && <div className={styles.title}>{title}</div>}
                                {children}
                                <button className={styles.close} onClick={onClose}>
                                    <Icon name='close' size='14' />
                                </button>
                            </div>
                        </OutsideClickHandler>
                    </div>
                </div>
            </ModalContext.Provider>
        ),
        document.body
    );
};

export default Modal;
